import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SavedsearchesModel } from '../../model/savedsearches.model';
import { TrackerDataService } from '../../services/acctactvty/trackerData.service';

declare let delta: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'saved-searches',
  templateUrl: 'saved-searches.component.html'
})
export class SavedSearchesComponent implements OnChanges {
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  savedTrips: any[] = [];
  @Output() savedTrip: EventEmitter<any> = new EventEmitter();
  @Input() searchResults: SavedsearchesModel;
  savedSearchesAvailableFlag = false;

  constructor(
    private savedsearchesService: TrackerDataService,
    public bsModalRef: BsModalRef,
    public el: ElementRef
  ) {}

  selectedTripDetails(flag) {
    this.savedTrip.emit(flag);
    this.close();
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.searchResults) {
      this.savedTrips = this.searchResults.savedTripsList;
    }
  }

  close() {
    this.bsModalRef.hide();
  }
}
